import { render } from "./userManageCrud.vue?vue&type=template&id=0d80f243"
import script from "./userManageCrud.vue?vue&type=script&lang=jsx"
export * from "./userManageCrud.vue?vue&type=script&lang=jsx"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__